import request from "../utils/fetch";

// 列表
export function list(data) {
  return request({
    url: "/equipment/enterprise/imsi/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 套餐下啦
export function setArr(data) {
  return request({
    url: "/user/rechargePackage/pullList",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 充值二维码
export function qrCode(data) {
  return request({
    url: "/equipment/enterprise/imsi/code",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 订单
export function order(data) {
  return request({
    url: "/equipment/enterprise/order/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 购买二维码
export function buyQrCode(data) {
  return request({
    url: "/equipment/enterprise/imsi/id",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 购买订单
export function buyOrder(data) {
  return request({
    url: "/equipment/enterprise/buy/order/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 购买列表
export function buyList(data) {
  return request({
    url: "/equipment/enterprise/buy/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 充值列表
export function topList(data) {
  return request({
    url: "/equipment/enterprise/card/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 物联网公共服务
// 已出库列表
export function simChuList(data) {
  return request({
    url: "/public/sim/asset/cart/get/bind/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
// 详情
export function simDetail(data) {
  return request({
    url: "/public/sim/asset/cart/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 折线图详情
export function monthChartsDetail(data) {
  return request({
    url: "/public/sim/asset/cart/month",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 套餐下拉
export function menuPull(data) {
  return request({
    url: "/public/sim/card/package/list/down",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 拉出支付码
export function payCode(data) {
  return request({
    url: "/public/sim/card/order/create",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 支付结果返回
export function payTrun(data) {
  return request({
    url: "/public/sim/card/order/pay/back",
    method: "get",
    requestBody: "query",
    loading: false,
    params: data,
  });
}

// 充值订单列表
export function topOrderList(data) {
  return request({
    url: "/public/sim/card/order/admin/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 列表导出导出
export function simExport(data) {
  return request({
    url: "/public/sim/card/order/export/user",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
    header: {
      headers: { "Content-Type": "application/x-download" },
    },
    responseType: "blob",
  });
}
